import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OnBoardingService } from '../../../../../api-services/onboarding.service';
//import { UserFileNote } from '../../../../../models/onboarding/user-file-note.model';
import { UserNotes } from '../../../../../models/onboarding/user-notes.model';
import { OnboardingUser } from '../../../../../models/onboarding/on-boarding-user.model';
import { SharedService } from '../../../../../services';
import { RoleService } from 'services/role.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recent-activity',
  templateUrl: './recent-activity.component.html',
  styleUrls: ['./recent-activity.component.css']
})
export class RecentActivityComponent implements OnInit {

  @Output() closeActivity: any = new EventEmitter();
  @Input() user: OnboardingUser;
  @Input() selectedUserId;
  @Input() selectedUserName;
  @ViewChild("chatInput") private chatInputEle: ElementRef;
  //userFileNotes: UserFileNote[] = [] as UserFileNote[];
  //userFileNote: UserFileNote = {} as UserFileNote;

  userNotes: UserNotes[] = [] as UserNotes[];
  userNote: UserNotes = {} as UserNotes;
  //shortName: string;
  //txtLog: string;
  isButtonHide = true;
  userName: string;
  isOnboardingUser = false;
  activeOnboardingUser = false;//JSON.parse(localStorage.getItem("activeOnboardingUser"));
  userId = JSON.parse(localStorage['userId']);
  darkScrollbarOptions: MCustomScrollbar.CustomScrollbarOptions = { axis: 'y', theme: 'light', setHeight: 'calc(100vh - 254px);' };

  constructor(private onboardingService: OnBoardingService,
    private sharedService: SharedService, private roleService: RoleService, private router: Router) {
    if (this.sharedService.getValue('name')) {
      var name = this.sharedService.getValue('name');
      this.userName = name;
    }
  }

  ngOnInit(): void {
    this.isOnboardingUser = this.roleService.isOnboardingUser;
    if (this.router.url == "/contact-dashboard/documents") {
      this.activeOnboardingUser = true;
    }
    if (this.isOnboardingUser == false)
    //{
    //}
    //else
    {
      this.userName = this.selectedUserName;
    }

    this.getUserFileNotes();
  }

  getUserFileNotes() {
    this.onboardingService.getUserNotes(this.selectedUserId).subscribe(response => {
      if (response) {
        this.userNotes = response.map(el => ({
          ...el,
          createdDate: this.sharedService.convertUTCTimeToLocalTime(el.createdDate)
        }));

        this.scrolltoBottom();
      }
    });
  }

  //getShortName(fullName: string) {    
  //  let shortName = fullName?.split(' ').map(n => n[0]).join('');
  //  return shortName 
  //}

  onSubmit(): void {
    this.userNote.userId = this.selectedUserId;
    this.onboardingService.insertUserNotes(this.userNote).subscribe(response => {
      if (response) {
        this.getUserFileNotes();
      }
    });
    this.userNote.notes = '';
  }

  close(action){
    this.closeActivity.emit(action);
  }

  getInititals(value: string) {
    const nameParts = value?.trim()?.split(' ');
    const initials = nameParts.map(part => part?.charAt(0).toUpperCase()).join('');

    return initials.length > 2 ? initials.substring(0, 2) : initials;
  }

  scrolltoBottom() {
    setTimeout(() => {
      document.getElementById('scrollTo')?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }, 0);
    
    this.chatInputEle.nativeElement.focus();
  }
}
